import React from 'react';
import AdminDiligenciaDetalhes from '@/pages/admin/AdminDiligenciaDetalhes';

export const DiligenciaDetalhes: React.FC = () => <AdminDiligenciaDetalhes />;

export default DiligenciaDetalhes;
